// ------------------------------------------------------------------------------
// name: blob
// author: mudas
// created: 2025/2/12
// ------------------------------------------------------------------------------

export function blobToFile(blob: Blob, name: string, type?: string) {
  return new File([blob], name, { type });
}

export function dataURItoBlob(dataURI: string) {
  // convert base64 to raw binary data held in a string
  // doesn't handle URLEncoded DataURIs - see SO answer #6850276 for code that does this
  const byteString = atob(dataURI.split(',')[1]);
  const mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];

  // write the bytes of the string to an ArrayBuffer
  const ab = new ArrayBuffer(byteString.length);
  const ia = new Uint8Array(ab);
  for (let i = 0; i < byteString.length; i++) {
    ia[i] = byteString.charCodeAt(i);
  }

  //New Code
  return new Blob([ab], { type: mimeString });
}

export function dataURLtoFile(dataUrl: string, filename: string) {
  const arr = dataUrl.split(',');
  const mime = arr[0].match(/:(.*?);/)![1];
  const bstr = atob(arr[1]);
  let n = bstr.length;
  const u8arr = new Uint8Array(n);
  while (n--) {
    u8arr[n] = bstr.charCodeAt(n);
  }
  return new File([u8arr], filename, { type: mime });
}
export const saveAsFile = (uid, filename, content) => {
  //创建file对象
  const blob = new Blob([content], { type: 'application/json' });
  //保存为格式为 .map的文件
  const file = blobToFile(blob, filename);
  Object.assign(file, {
    uid,
    fileName: filename,
    status: 'done',
  });
  return file;
};
export const fetchBlobFromURL = async (url: string) => {
  return fetch(url).then((response) => {
    if (!response.ok) {
      throw new Error(`Network response was not ok for URL: ${url}`);
    }
    return response.blob();
  });
};
